'use strict';var _dec,_desc,_value,_class;function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key]});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=!0}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=void 0}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null}return desc}

const _=require('pulsar-utils/dist-es6/_');
const BaseController=require('../../../../../../dist-es6/client/angularCommon/baseController');
const HandleUncaughtErrors=require('../../../../../../dist-es6/client/services/uncaughtErrorHandler').Annotations.HandleUncaughtErrors;
const ModalSubmissionResult=require('../../../../../../dist-es6/client/angularCommon/modalSubmissionResult');
const SocketResponse=require('../../../../../../dist-es6/client/dtos/socketResponse');let

ChangeUserPasswordModalController=(_dec=














































HandleUncaughtErrors(ModalSubmissionResult.FromError),(_class=class ChangeUserPasswordModalController extends BaseController{static get $inject(){return['$modalInstance','userService','uiCommandFactory','uncaughtErrorHandler']}constructor($modalInstance,userService,uiCommandFactory,uncaughtErrorHandler){super(uncaughtErrorHandler);this._$modalInstance=$modalInstance;this._userService=userService;this._changePasswordCommand=uiCommandFactory.makeForModal($modalInstance,this._changePassword.bind(this));this._submissionErrorTypes={invalidCurrentPassword:'invalid current password.',minimumLengthProposed:'invalid minimum length'};this._submissionFailed=!1}onCancel(){this._$modalInstance.dismiss()}get currentPassword(){return this._currentPassword}get proposedPassword(){return this._proposedPassword}set currentPassword(currentPassword){this._currentPassword=currentPassword}set proposedPassword(proposedPassword){this._proposedPassword=proposedPassword}get changePasswordCommand(){return this._changePasswordCommand}get submissionFailed(){return this._submissionFailed}
async _changePassword(){
this._submissionFailed=!1;

let updateResult=await this._userService.changePassword({
current:this.currentPassword,
proposed:this.proposedPassword});


if(!SocketResponse.succeeded(updateResult)){
this._submissionFailed=!0;
return ModalSubmissionResult.KeepOpen;
}

return ModalSubmissionResult.Close();
}},(_applyDecoratedDescriptor(_class.prototype,'_changePassword',[_dec],Object.getOwnPropertyDescriptor(_class.prototype,'_changePassword'),_class.prototype)),_class));


module.exports=ChangeUserPasswordModalController;
//# sourceMappingURL=changeUserPasswordModalController.js.map
